import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Divider, Loader } from '@gasbuddy/react-components';
import RatingsDonutCharts from './ratings-donut-charts';
import styles from './styles.css';
import { StationCategoryRatingType } from '../../../utils/prop-types/rating-types';

const { api, logError } = require('../../../../lib/bputils').default;
const { gTagEvent } = require('../../../../lib/global-site-tag').default;

class CategoryRatingsCard extends React.Component {
  static propTypes = {
    categories: PropTypes.arrayOf(StationCategoryRatingType).isRequired,
  }

  constructor(props) {
    super(props);
    this.sendGTagEvent = false;
    this.state = {
      categoryOptions: [],
      selectedCategoryId: 1,
      isLoading: true,
      ratingCategoryError: false,
    };
  }

  componentDidMount = async () => {
    this.sendGTagEvent = false;
    try {
      const res = await api.get({
        path: '/rating-categories',
        requestId: 'getAllRatingCategories',
      });
      this.setState(() => ({
        categoryOptions: res,
        isLoading: false,
      }));
    } catch (err) {
      this.setState(() => ({ ratingCategoryError: true }));
      logError(err);
    }
  }

  handleOnRatingCategoryChange = (event) => {
    event.persist();

    const selectedCategoryId = Number(event.target.value);
    this.setState(() => ({
      selectedCategoryId,
    }));

    if (this.sendGTagEvent) {
      gTagEvent('Category Rating Card', 'Changed Rating Category', { selectedCategoryId });
    }
    this.sendGTagEvent = true;

    const selectedCategoryRatings = (this.props.categories || []).find(c => c.category_id === Number(event.target.value));
    this.ratingsDonutChartRef.updateSeries(selectedCategoryRatings || {});
  }

  render = () => {
    const { ratingCategoryError } = this.state;
    if (ratingCategoryError) {
      throw new Error('Error while fetching Rating Categories');
    }
    const { categories } = this.props;
    const { categoryOptions, selectedCategoryId, isLoading } = this.state;
    const selectedCategoryInformation = categoryOptions.find(c => c.id === selectedCategoryId);
    const selectedCategoryRatings = categories.find(c => c.category_id === selectedCategoryId);
    const selectedCategory = { ...selectedCategoryInformation, ...selectedCategoryRatings };

    return (
      <div>
        { isLoading ? <Loader className={styles.center} /> : (
          <div>
            <div>
              <Dropdown
                style={{ width: '50%' }}
                options={categoryOptions.map(category => ({
                  label: category.name,
                  value: category.id,
                }))}
                value={selectedCategoryId}
                onChange={this.handleOnRatingCategoryChange}
              />
            </div>
            <div>
              <RatingsDonutCharts
                positive={selectedCategory.positive || 0}
                neutral={selectedCategory.neutral || 0}
                negative={selectedCategory.negative || 0}
                ref={(el) => { this.ratingsDonutChartRef = el; }}
              />
            </div>
            <Divider />
            <div className={styles.footer}>
              { `Percentages are based on ${
                (selectedCategoryRatings?.positive || 0)
                + (selectedCategoryRatings?.negative || 0)
                + (selectedCategoryRatings?.neutral || 0)} total ${selectedCategory.name.toLowerCase()} ratings` }
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CategoryRatingsCard;
